<style lang="less">
/*style overrides to accommodate forms with comments*/
.public-page-body .body-content {
    padding: 0;
}
</style>
<style lang="less" scoped>
@import "/lib/Colors.less";

.testModeBar {
    margin-bottom: 0;
    text-align: center;
    font-size: 2em;
    border-radius: 0;
    height: 75px;
}

.alert-test {
    background: #111;
    color: #fff;
    font-weight: 600;
}

.alert-in-progress,
.alert-issues {
    background: @warning;
    color: #000;
    font-weight: 600;
    border-radius: 0;
}

.notificationBarTop {
    position: fixed;
    width: 100%;
    z-index: 1029;
    a {
        text-decoration: underline;
    }
}
@added: #208337;
@changed: #2568db;
@deleted: #d70015;
.adminDiffControlContainer {
    padding: 10px 15px;
    .changedKey,
    .deletedKey,
    .addedKey {
        color: white;
    }
    .changedKey {
        background: @changed;
    }
    .deletedKey {
        background: @deleted;
    }
    .addedKey {
        background: @added;
    }
}

.changed,
.deleted,
.new {
    border-style: dashed;
    border-width: 2px;
}
.changed {
    border-color: @changed !important;
}
.deleted {
    border-color: @deleted !important;
}
.new {
    border-color: @added !important;
}
.submissions-left-col {
    // container: leftSubmissions / inline-size;
    background: #ffffff;
}
.submissions-right-col {
    border-left: 1px solid #cccccc;
    background: whitesmoke;
}
.task-divider {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    position: absolute;
    top: 0;
    height: 100%;
    width: 4px;
    z-index: 4;

    .icon {
        display: inline-flex;
        align-items: center;
        height: 50px;
        outline: none;
        box-shadow: none;
        border-radius: 0;
        cursor: pointer;
        &:focus {
            outline: auto;
        }
        &:hover,
        &:focus {
            background: @light-gray-dark;
        }
    }

    .task-divider-line {
        display: inline-flex;
        height: 100%;
        background: transparent;
        padding: 1.5px;
        cursor: col-resize;
        -webkit-transition: all ease 0.15s;
        transition: all ease 0.15s;
        &:hover {
            background: dodgerblue;
        }
    }
}

.issues .icon-attention-solid:before {
    color: @warning;
}

.nav-item.disabled {
    color: #999;
}

.nav-tabs {
    flex-basis: content;
}
// @container leftSubmissions (max-width: 576px) {
//     .button-controls {
//         width: 100%;
//     }
// }

@media (max-width: 767px) {
    .left,
    .right {
        display: inline-block;
        width: 100%;
        padding: 5px;
    }
    .right {
        text-align: right;
        border-top: 1px solid #ccc;
    }
    .left > .key {
        border-bottom: 1px solid #ccc;
        width: calc(100% + 10px);
        margin: -5px -5px 5px -5px;
        padding: 5px;
    }
}

@media (max-width: 767px) {
    .df-public-nav.df-collapsed .list-group-item:not(.active) {
        border-width: 0 !important;
    }
}
</style>
<template>
    <div>
        <!--
        {{ status }} <br/>

        {{ pageGroups.map(i => i.label) }} <br/>
        {{ activeSegments == null }} || {{ activeSegments == null ? 'null' : activeSegments.length }} <br/>
        {{ availableSegments == null }} || {{ availableSegments == null ? 'null' : availableSegments.length }} <br/>
        {{ segment == '' }} || {{ segment == null }} || {{ segment }} <br/>
        {{ enabledPages == null }} || {{ enabledPages != null ? enabledPages.length : 'null' }}
        -->
        <picture id="loader" v-if="!initialLoadFinished || formDataLoading || forcingRedirect || (activeSegments == null && enabledPages == null)">
            <!--
            I[ {{ initialLoadFinished }} ] L[ {{ formDataLoading }} ] R[ {{ forcingRedirect }} ] A[ {{ activeSegments != null }} ] E[ {{ enabledPages != null }} ]
            -->
            <LoadingWheel :width="100" />
        </picture>
        <div v-else>
            <div v-if="testMode" class="alert alert-test testModeBar">TEST MODE <span aria-hidden>&gt;</span> NOT A REAL FORM <span aria-hidden>&lt;</span> TEST MODE</div>
            <div v-if="hasIssues" class="alert alert-issues text-center p-1 m-0">This submission has issues.</div>
            <OfflineNotice v-if="isOffline" />
            <div v-else>
                <LoginBanner v-if="showPageNav && hasMultiplePages && !isViewOnly" />
                <div class="container-fluid" :class="{ 'has-form-comments': showComments, 'no-form-comments': !showComments, testModeContainer: testMode }">
                    <div class="row flex-nowrap" ref="ReviewContainer">
                        <!-- <div class="submissions-left-col left-nav-sec" v-if="showComments">
                        <h1 style="margin-top:5px;" class="admin-content-heading">Activity</h1>
                        <Comments :data="formData" :showAdminFormLevelControls="this.adminReview" />
                    </div> -->
                        <div :style="rightPageGroups.length > 0 && rightPageGroups.some(i => i.pages.length > 0) ? { flex: '0 0 ' + leftWidthPercentage } : {}" :class="rightPageGroups.length > 1 || adminReview ? ['submissions-left-col', 'col', 'admin-content'] : ['tile', 'container']" v-if="leftPageGroups.length > 0 || showComments">
                            <div class="row no-gutters justify-content-between align-items-start">
                                <ul class="col nav nav-tabs" v-if="adminReview">
                                    <li class="nav-item" v-if="leftPageGroups.length > 0" :class="{ disabled: hasIssues }">
                                        <a tabindex="0" class="nav-link" :class="{ active: reviewTab == 'task' }" @click.prevent="changeReviewTab('task')">Task</a>
                                    </li>
                                    <li class="nav-item" v-if="showComments">
                                        <a tabindex="0" class="nav-link" :class="{ active: reviewTab == 'comments' }" @click.prevent="changeReviewTab('comments')">Comments</a>
                                    </li>
                                    <li class="nav-item" v-if="showFiles">
                                        <a tabindex="0" class="nav-link" :class="{ active: reviewTab == 'files' }" @click.prevent="changeReviewTab('files')">Files</a>
                                    </li>
                                    <li class="nav-item" v-if="showHistory">
                                        <a tabindex="0" class="nav-link" :class="{ active: reviewTab == 'history' }" @click.prevent="changeReviewTab('history')">History</a>
                                    </li>
                                    <li class="nav-item issues" v-if="hasIssues">
                                        <a tabindex="0" class="nav-link" :class="{ active: reviewTab == 'issues' }" @click.prevent="changeReviewTab('issues')">
                                            <span class="icon p-0 m-0 pl-0 icon-attention-solid"></span>
                                            Issues
                                        </a>
                                    </li>
                                </ul>
                                <div v-if="adminReview" class="button-controls mb-3 align-items-center" :class="{ 'btn-group': isWorkflowManualOverrideVisible || isSubmittableStatusChangeVisible }">
                                    <template v-if="isWorkflowReturnVisible">
                                        <HelpIcon class="mr-1" text="No email found for returning or Allow returning is not set" v-if="!isWorkflowReturnEnabled" />
                                        <button id="returnSubmissionBtn" class="btn btn-sm btn-outline-secondary cancel dfNavButton w-100" type="button" :disabled="!isWorkflowReturnEnabled" @click.prevent="returnSubmission($event)">Return Submission</button>
                                    </template>
                                    <button id="dropdownBtn" type="button" v-if="isWorkflowManualOverrideVisible || isSubmittableStatusChangeVisible" class="btn btn-sm btn-outline-secondary dropdown-toggle dropdown-toggle-split" @click.prevent="toggleReturnDropdown">
                                        <span class="sr-only">Toggle Dropdown</span>
                                    </button>
                                    <div id="dropdownMenu" class="dropdown-menu dropdown-menu-right" :class="showReturnDropdown ? ['show'] : []">
                                        <button id="startWorkflowManualOverride" class="dropdown-item btn-sm cancel dfNavButton" type="button" :disabled="!isWorkflowManualOverrideVisible" @click.prevent="startWorkflowManualOverride" v-if="isWorkflowManualOverrideVisible">Manual Override</button>
                                        <button id="startSubmittableStatusChange" class="dropdown-item btn-sm cancel dfNavButton" type="button" :disabled="!isSubmittableStatusChangeVisible" @click.prevent="startSubmittableStatusChange" v-if="isSubmittableStatusChangeVisible">Change Status</button>
                                        <button id="deleteDraft" class="dropdown-item btn-sm cancel dfNavButton text-danger" type="button" :disabled="!isSubmittableDeleteVisible" @click.prevent="deleteDraft(true, $event)" v-if="isSubmittableDeleteVisible">Delete Submission</button>
                                    </div>
                                </div>
                            </div>
                            <Diff :inlineAdminPreview="settings.inlineAdminPreview" />
                            <PageSide :page-groups="leftPageGroups" :pageI="leftPage" @set-page="setLeftPage($event)" @show-page-nav="setShowPagenav($event)" @current-page="setCurrentLeftPage($event)" v-show="reviewTab == 'task'" v-if="leftPageGroups.length > 0 && leftPageGroups.some(i => i.pages.length > 0)" />
                            <CommentsTab class="comments-tab" v-show="reviewTab == 'comments'" />
                            <Files v-show="reviewTab == 'files'" />
                            <History v-show="reviewTab == 'history'" />
                            <Issues v-show="reviewTab == 'issues'" />
                        </div>
                        <div class="submissions-right-col col admin-content flex-grow-1 p-0" v-if="rightPageGroups.length > 0 && rightPageGroups.some(i => i.pages.length > 0)">
                            <div v-if="hasPartiallyCompletedForms && adminReview" class="alert alert-in-progress text-center p-1 m-0">There are partially completed form(s) in this submission.</div>
                            <div class="container tile p-3">
                                <Diff :inlineAdminPreview="settings.inlineAdminPreview" v-if="leftPageGroups.length == 0" />
                                <PageSide :page-groups="rightPageGroups" :pageI="rightPage" @set-page="setRightPage($event)" @show-page-nav="setShowPagenav($event)" @current-segment="setCurrentSegment($event)" />
                            </div>
                        </div>
                    </div>
                    <div class="task-divider" v-show="rightPageGroups.length > 0 && rightPageGroups.some(i => i.pages.length > 0) && ((leftPageGroups.length > 0 && leftPageGroups.some(i => i.pages.length > 0)) || showComments)" :style="{ left: dividerLeft }">
                        <a tabindex="0" class="btn btn-bare p-0 icon icon-caret-left" :class="{ disabled: !resizableLeft }" @click.prevent="decreaseLeftWidth()" draggable="true"><span class="sr-only">Resize left</span></a>
                        <span class="task-divider-line" :draggable="resizableLeft || resizableRight" @dragstart.stop="resizeDragStart($event)" @drag.stop="resizeDragMove($event)" @dragend.stop.prevent="resizeDragEnd($event)"></span>
                        <a tabindex="0" class="btn btn-bare p-0 icon icon-caret-right" :class="{ disabled: !resizableRight }" @click.prevent="increaseLeftWidth()" draggable="true"><span class="sr-only">Resize right</span></a>
                    </div>
                    <div v-show="tempLeftWidth != null" :style="{ left: tempLeftWidth }" class="resize-marker"></div>
                </div>
            </div>
            <div v-if="testMode" class="alert alert-test testModeBar">TEST MODE <span aria-hidden>&gt;</span> NOT A REAL FORM <span aria-hidden>&lt;</span> TEST MODE</div>
        </div>
    </div>
</template>
<script lang="ts">
//import NonIndexStyles from '@/lib/nonIndexStyles.3.vue'
import { defineComponent, ref, watch, onActivated, onMounted, onUnmounted, computed, nextTick, provide, SetupContext, inject, reactive } from "vue";
import { asyncComputed } from "@vueuse/core";
import { useObservable } from "@vueuse/rxjs";
import PageSide from "./PageSide.3.vue";
import { StandardFormStatus } from "@cs/StandardFormStatus";
import { FormAccessPurpose } from "@cs/FormAccessPurpose";
import { Permissions } from "@cs/Permissions";
import { fetchXsrf } from "@/lib/fetchHelpers.3";
import { map, switchMap, startWith } from "rxjs/operators";
import { combineLatest, from, Observable, Subscription } from "rxjs";
//import { combineLatestArray } from "@/lib/combineLatestArray";
import mitt from "mitt";
import delay from "@/lib/delayPromise";
import firstOrNull from "@/lib/first";
import LoginBanner from "./Page/LoginBanner.3.vue";
import OfflineNotice from "./Page/OfflineNotice.3.vue";
import Diff from "./Page/Diff.3.vue";
import Issues from "./Page/Issues.3.vue";
import History from "./Page/History.3.vue";
import Files from "./Page/Files.3.vue";
import CommentsTab from "./Page/Comments.3.vue";
import DeleteConfirmModal from "./dialogs/DeleteConfirm.3.vue";
import DeleteSuccessModal from "./dialogs/DeleteSuccess.3.vue";
import ReturnConfirmModal from "./dialogs/ReturnConfirm.3.vue";
import ReturnSuccessModal from "./dialogs/ReturnSuccess.3.vue";
import ResendConfirmModal from "./dialogs/ResendConfirm.3.vue";
import ResendSuccessModal from "./dialogs/ResendSuccess.3.vue";
import ChangeStatusConfirmModal from "./dialogs/ChangeStatusConfirm.3.vue";
import ChangeStatusSuccessModal from "./dialogs/ChangeStatusSuccess.3.vue";
import SubmitConfirmModal from "./dialogs/SubmitConfirm.3.vue";
import SubmitSuccessModal from "./dialogs/SubmitSuccess.3.vue";
import SubmitFailureModal from "./dialogs/SubmitFailure.3.vue";
import SubmitErrorsModal from "./dialogs/SubmitErrors.3.vue";
import LockActionModal from "./dialogs/LockAction.3.vue";
import LoadingModal from "./dialogs/Loading.3.vue";

import SignDialog from "./dialogs/Sign.3.vue";
import { usePageStore, toObserverComputed } from "./pageState/store";
import { useMainStore } from "@/mainStore";
import type PageDef from "./elements/PageDef";
import type FormDef from "./elements/FormDef";
import WorkflowManualOverrideModal from "./dialogs/WorkflowManualOverride.3.vue";
import WorkflowManualOverrideSuccessModal from "./dialogs/WorkflowManualOverrideSuccess.3.vue";
import { isSignatureDef } from "./elements/SignatureDef";
import { showModalInjectKey, showModal, ModalEvent, changePage, changePageInjectKey, getLoginUrlInjectKey } from "@/AppShell.3.vue.InjectKeys";
import { ICustomConfirmElement, isICustomConfirmElement, isIBlockSubmitElement, isICustomReceiptElement, isICustomViewElement, isIShouldSkipConfirmElement, IShouldSkipConfirmElement, isICustomSubmitTextElement, IHasCustomSubmitTextElement, BaseElementDefBase, IPostSubmitRedirectElement, isIPostSubmitRedirectElement, isIShouldSkipCompletionElement, LockAction } from "./elements/BaseElementDef";
import LoadingWheel from "@/lib/LoadingWheel.3.vue";
import HelpIcon from "@/lib/HelpIcon.3.vue";
import { gotoIndexInjectKey, forceLoginInjectKey, submitInjectKey, deleteDraftInjectKey, pageStatusFetcherInjectKey, resendEmailInjectKey, submitButtons$InjectKey, loadingInjectKey } from "./Page.3.vue.InjectKeys";
import { DirectLinkTemplateSettings } from "@cs-ts/direct-link-template-settings";
import StateFormDef from "./elements/StateFormDef";
import SignatureDef from "./elements/SignatureDef";
import flattenArrays from "@/lib/flattenArrays";
import { isNullOrWhitespace } from "@/lib/whitespaceMethods";
import { KnownFeatureFlags } from "@cs/KnownFeatureFlags";
const DEFAULT_FORM_SUBMIT_TEXT = "Submit";
interface Props {
    settings: {
        inModal: boolean;
        adminPreview: boolean;
        previewData?: any; // eslint-disable-line @typescript-eslint/no-explicit-any -- TODO?
        adminReview: boolean;
        areaUrlSlug?: string;
        areaCode?: string;
        formId?: string;
        formName?: string;
        formVersion?: string;
        formHash?: string;
        urlSlug?: string;
        page?: string;
        testMode?: string;
    };
}
//const debugSub = (a: Observable<any>) => {
//    a.subscribe(b => {
//        debugger;
//    });
//};
export default defineComponent({
    props: ["settings"],
    components: {
        LoadingWheel,
        HelpIcon,
        PageSide,
        CommentsTab,
        History,
        Issues,
        Files,
        Diff,
        LoginBanner,
        OfflineNotice,
    },
    setup(props: Props, { emit }: SetupContext) {
        const leftPage = ref(null as null | number);
        const rightPage = ref(null as null | number);
        const verifyData = ref({});
        const verifyFailureMessages = ref([]);
        const isInitialCreate = ref(true);
        const forcingRedirect = ref(false);
        const initialLoadFinished = ref(false);
        const showLoginSlidedown = ref(false);
        //const skipConfirmModal = ref(false);
        const isSubmitting = ref(false);
        const pageStatus = ref({});
        const pageStatusSubscriptions = ref([] as Subscription[]);
        const reviewTab = ref("task");
        const leftWidth = ref(50);
        const tempLeftWidth = ref(undefined as number | undefined);
        const ReviewContainer = ref(null as unknown as HTMLElement);
        const showPageNav = ref(false);
        const currentSegment = ref<StateFormDef>(null!);
        const currentLeftPage = ref<PageDef>(null!);

        const pageStore = usePageStore();
        const mainStore = useMainStore();

        const showModal = inject(showModalInjectKey) as showModal;
        const changePage = inject(changePageInjectKey) as changePage;
        const eventBus = mitt();
        provide("pageEventBus", eventBus);

        const submitButtons$ = combineLatest([toObserverComputed(() => pageStore.formDataTyped), pageStore.segment$]).pipe(
            switchMap(([formData2, segment]) => {
                if (formData2 == null) {
                    return from([]);
                }
                const formData = formData2.getSegmentView(segment!, null!);
                const submitButtonCalcId = pageStore.formSettings!.submitButtonTextCalculationId;
                const submitButtonObservable = (submitButtonCalcId == null ? from([null as string[] | null]) : formData.resolveCalculation(submitButtonCalcId)).pipe(map(v => (v ? v.join("") : pageStore.formSettings!.effectiveSubmitButtonText)));
                type Button = { trigger: string; text: string; order: number };
                type BA = BaseElementDefBase & { submitButtons?: () => Button[]; submitButtons$?: () => Observable<Button> };
                const buttonElements = formData.getElementsByFilter(i => !!(i as BA).submitButtons || !!(i as BA).submitButtons$) as BA[];
                let buttons$: Observable<{ trigger: string; text: string; order: number }[]>;
                if (buttonElements.length > 0) {
                    buttons$ = combineLatest(buttonElements.map(element => (element.submitButtons$ ? element.submitButtons$() : from([element.submitButtons!()])))).pipe(
                        map(customButtons => {
                            return customButtons.flat();
                        }),
                    );
                } else {
                    buttons$ = from([[] as Button[]]);
                }
                let buttonText$;
                const buttonTextElements = formData.getElementsByFilter(isICustomSubmitTextElement) as (IHasCustomSubmitTextElement & BaseElementDefBase)[];
                if (buttonTextElements.length > 0) {
                    const customSubmitText$ = buttonTextElements.map(element => combineLatest([element.hasCustomSubmitText$ ? element.hasCustomSubmitText$() : element.hasCustomSubmitText ? from([element.hasCustomSubmitText()]) : from([false]), element.submitText$ ? element.submitText$() : from([element.submitText!()])]));
                    buttonText$ = combineLatest([submitButtonObservable, combineLatest(customSubmitText$)]).pipe(
                        //@ts-expect-error
                        map(([effectiveSubmitButtonText, customSubmitTextData]: [string, string[]]) => {
                            if (effectiveSubmitButtonText != DEFAULT_FORM_SUBMIT_TEXT) {
                                customSubmitTextData = customSubmitTextData.filter(i => i[0]);
                            }
                            customSubmitTextData = customSubmitTextData.filter(i => i[1]);
                            if (customSubmitTextData.length > 0) {
                                return customSubmitTextData[0][1];
                            } else {
                                return effectiveSubmitButtonText;
                            }
                        }),
                    );
                } else {
                    buttonText$ = submitButtonObservable;
                }
                return combineLatest([buttons$, buttonText$]).pipe(
                    map(([buttons, buttonText]) => {
                        if (buttons.length > 0) {
                            return [...buttons.map(button => ({ ...button, text: button.text || DEFAULT_FORM_SUBMIT_TEXT }))].sort((a, b) => (a.order || 0) - (b.order || 0));
                        } else {
                            return [{ trigger: null, text: buttonText || DEFAULT_FORM_SUBMIT_TEXT }];
                        }
                    }),
                );
            }),
            startWith([{} as { trigger: null; text: null }]),
        );

        const submitButtons = useObservable(submitButtons$);

        //submitButtons: this.submitButtons$;
        //const segment = useSubject(pageStore.segment$),
        //visiblePages: this.visiblePages$,
        //enabledPages: this.enabledPages$,
        //isSubmittable: this.isSubmittable$,

        const formDataLoading = computed(() => pageStore.formDataLoading);

        const formId = computed(() => pageStore.formId);
        const testMode = computed(() => pageStore.testMode && !adminPreview.value);
        const adminReview = computed(() => pageStore.adminReview);
        const adminPreview = computed(() => pageStore.adminPreview);
        const activeSegments = computed(() => pageStore.activeSegments);
        const enabledPages = useObservable(pageStore.enabledPages$);
        const status = useObservable(pageStore.status$);
        //const endUserStatuses = computed(() => pageStore.endUserStatuses);
        const canSeeAll = computed(() => pageStore.formData?.can[Permissions.SeeAllForms]);
        const showComments = computed(() => {
            return (pageStore.adminReview && canSeeAll.value) || (pageStore.comments != null && pageStore.comments.length > 1);
        });
        const showHistory = computed(() => canSeeAll.value);
        const showFiles = computed(() => canSeeAll.value);
        const isWorkflow = computed(() => pageStore.isWorkflow);
        const hasPartiallyCompletedForms = asyncComputed(async () => {
            const hasStatus = (status: string) => ["InProgress", "Returned"].includes(status);
            const pagesWithStatus = (pageStore.segments || []).filter(segment => rightPageGroups.value.some(pageGroup => pageGroup.pages.some(page => page.definition.settings.segment == segment.id)) && hasStatus(segment.status));
            return isWorkflow.value ? pagesWithStatus.length > 0 : hasStatus(status.value!);
        });
        const hasIssues = computed(() => pageStore.hasIssues);
        const isViewOnly = computed(() => pageStore.isViewOnly);
        const isOffline = computed(() => pageStore.isOffline);
        const hasMultiplePages = computed(() => pageStore.visiblePages != null && pageStore.visiblePages.length > 1);

        const isWorkflowReturnVisible = computed(() => {
            return !adminPreview.value && adminReview.value && formId.value != null && pageStore.hasCompletedSegmentsToReturnTo && (canSeeAll.value || pageStore.formData?.can[FormAccessPurpose.AdminWorkflowAssign] || pageStore.formData?.can[FormAccessPurpose.AdminWorkflowSubmit]);
        });
        const hasReturnEmails$ = computed(() => {
            return toObserverComputed(() => pageStore.completedSegments).pipe(
                switchMap(completedSegments => {
                    const returnEmail$s = (completedSegments ?? []).filter(i => i.definition.settings.returnEmailAddressCalculationId != null).map(i => i.resolveCalculation(i.definition.settings.returnEmailAddressCalculationId!));
                    return combineLatest(returnEmail$s).pipe(map(i => flattenArrays(i).length > 0));
                }),
            );
        });
        const hasReturnEmails = useObservable(hasReturnEmails$.value);
        const isWorkflowReturnEnabled = computed(() => {
            return isWorkflowReturnVisible.value && (!pageStore.anonymousUser || hasReturnEmails.value);
        });
        const isWorkflowManualOverrideVisible = computed(() => {
            return !adminPreview.value && adminReview.value && isWorkflow.value && pageStore.canChangeStatus;
        });
        const isSubmittableStatusChangeVisible = computed(() => {
            return !adminPreview.value && adminReview.value && !isWorkflow.value && pageStore.canChangeStatus;
        });
        const isSubmittableDeleteVisible = computed(() => {
            return !adminPreview.value && adminReview.value && !isWorkflow.value && pageStore.canChangeStatus && pageStore.canDeleteSubmissions;
        });

        const pageGroups = computed(() => {
            const result = (pageStore.initializedSegments || []).map(i => {
                return {
                    id: i.id as string | null,
                    label: i.definition.settings.displayLabel,
                    pages: (pageStore.visiblePages || []).filter(j => j.definition.settings.segment == i.id),
                };
            });
            const extra = (pageStore.visiblePages || []).filter(i => !(pageStore.uninitializedSegments || []).some(j => j.id == i.definition.settings.segment) && !result.some(j => j.pages.some(k => k == i)));
            if (extra.length > 0) {
                result.push({ id: null, label: "Unknown", pages: extra });
            }
            return result.filter(i => i.pages.length > 0);
        });
        const leftPageGroups = computed(() => {
            return pageGroups.value.filter(i => i.pages.some(i => !pageStore.isPageObjViewOnly(i, true)));
        });
        const rightPageGroups = computed(() => {
            return pageGroups.value.filter(i => !i.pages.some(i => !pageStore.isPageObjViewOnly(i, true)));
        });
        const leftWidthPercentage = computed(() => leftWidth.value + "%");
        const dividerLeft = computed(() => {
            const dividerWidth = 34;
            return "calc(" + leftWidthPercentage.value + " - " + dividerWidth / 2 + "px)";
        });
        const resizableLeft = computed(() => {
            return leftWidth.value > 30;
        });
        const resizableRight = computed(() => {
            return leftWidth.value < 70;
        });

        // Subscriptions have to be watched in created
        watch(enabledPages, () => {
            const pageStatusV = reactive({} as Record<string, string>);
            Object.values(pageStatusSubscriptions.value).forEach(value => {
                value.unsubscribe();
            });

            const pageStatusSubscriptionsV = [] as Subscription[];
            (enabledPages.value ?? []).forEach((page: PageDef) => {
                pageStatusSubscriptionsV.push(
                    page.clientStatus$().subscribe((status: string) => {
                        pageStatusV[page.vmId as string] = status;
                    }),
                );
            });
            pageStatusSubscriptions.value = pageStatusSubscriptionsV;
            pageStatus.value = pageStatusV;
        });

        const changeReviewTab = (tab: string) => {
            reviewTab.value = tab;
        };

        const increaseLeftWidth = () => {
            if (resizableRight.value) {
                leftWidth.value = 75;
            }
            // TODO: local or session storage cols
        };
        const decreaseLeftWidth = () => {
            if (resizableLeft.value) {
                leftWidth.value = 25;
            }
            // TODO: local or session storage cols
        };
        const setLeftPage = (page: number) => {
            leftPage.value = page;
        };
        const setRightPage = (page: number) => {
            rightPage.value = page;
        };
        const resizeDragStart = (event: DragEvent) => {
            event.dataTransfer!.clearData();
            event.dataTransfer!.setDragImage(event.target as Element, event.offsetX, event.offsetY);
            tempLeftWidth.value = leftWidth.value;
            return true;
        };
        const resizeDragMove = (event: DragEvent) => {
            tempLeftWidth.value = _getWidth(event);
            return true;
        };
        const resizeDragEnd = (event: DragEvent) => {
            // TODO: local or session storage cols
            leftWidth.value = _getWidth(event);
            tempLeftWidth.value = undefined;
            return true;
        };
        const _getWidth = (event: DragEvent) => {
            var containerBox = ReviewContainer.value.getBoundingClientRect();
            var width = containerBox.width;
            var offset = event.pageX - containerBox.left;
            var newWidth = Math.round(100 * (offset / width));
            return Math.max(25, Math.min(75, Math.trunc(newWidth)));
        };

        const gotoIndex = () => {
            if (props.settings.inModal) {
                emit("close");
            } else if (adminReview.value) {
                emit("change-page", { page: "Admin" });
            } else if (adminPreview.value) {
                // ignore
            } else {
                emit("change-page", { page: "Index" });
            }
        };

        const getLoginUrl = inject(getLoginUrlInjectKey) as (mode: number, returnUrl: string) => Promise<string>;

        const forceLogin = async () => {
            forcingRedirect.value = true;
            await nextTick();
            await pageStore.pendingActionPromise;
            //TODO?await this.$root.tenantDataPromise;
            const returnUrl = await mainStore.getUrl("draftGoto", { areaCode: pageStore.formTenantCode, formId: formId.value, page: leftPage.value });
            const url = await getLoginUrl(0, returnUrl);
            window.location.assign(url);
        };

        //TODO duplicate of PageSide
        const throwIfViewOnly = () => {
            if (pageStore.isViewOnly) {
                throw new Error("Should not be called for view only pages");
            }
        };

        const submit = async (triggerKey: string | null, _event: Event) => {
            if (!triggerKey && (submitButtons.value ?? []).length == 1) {
                triggerKey = submitButtons.value![0].trigger;
            }
            throwIfViewOnly();
            //let submitting = false; // TODO better implementation?
            let skipConfirmA = (await Promise.all((pageStore.formDataTyped!.getSegmentView(pageStore.segment, triggerKey).getElementsByFilter(isIShouldSkipConfirmElement) as IShouldSkipConfirmElement[]).map(i => (i.shouldSkipConfirm ? i.shouldSkipConfirm() : false)))).filter(i => i != null);
            let skipConfirm = skipConfirmA.length > 0 && skipConfirmA.every(i => i);
            if (skipConfirm && !pageStore.adminPreview && (triggerKey || ((submitButtons.value ?? []).length == 1 && !submitButtons.value![0].trigger))) {
                forcingRedirect.value = true;
                await (
                    await submitFunction(triggerKey)
                )();
            } else {
                let confirmComponents = await Promise.all(
                    pageStore
                        .formDataTyped!.getSegmentView(pageStore.segment, triggerKey)
                        .getElementsByFilter(i => isICustomConfirmElement(i) && i.hasCustomConfirmComponent(pageStore.adminPreview!))
                        .map(item => (item as ICustomConfirmElement).getCustomConfirmComponent(pageStore.adminPreview!)),
                );
                confirmComponents = Array.prototype.concat.apply([], confirmComponents);
                let blockSubmit$s = await Promise.all(
                    pageStore
                        .formDataTyped!.getSegmentView(pageStore.segment, triggerKey)
                        .getElementsByFilter2(isIBlockSubmitElement)
                        .map(item => item.blockSubmit$()),
                );
                blockSubmit$s = Array.prototype.concat.apply([], blockSubmit$s);
                const blockSubmit$ = blockSubmit$s.length > 0 ? combineLatest(blockSubmit$s).pipe(map(a => a.some(i => i))) : from([false]);

                showModal(
                    SubmitConfirmModal,
                    {
                        submitFunction: submitFunction,
                        confirmComponents: confirmComponents,
                        blockSubmit$: blockSubmit$,
                        //@ts-ignore VUE2 issue?
                        submitButtons: (submitButtons.value ?? []).filter((i: NonNullable<(typeof submitButtons)["value"]>[0]) => i.trigger == null || i.trigger == triggerKey || triggerKey == null),
                        triggerKey: triggerKey,
                    },
                    {
                        "before-closed": function (event: ModalEvent) {
                            if (isSubmitting.value) {
                                event.stop();
                            }
                        },
                    },
                );
            }
        };
        const submitFunction = async (triggerKey: string | null) => {
            isSubmitting.value = true;
            //submitting = true;
            const segment = pageStore.segment;
            await pageStore.pendingActionPromise; // TODO move into module?
            const submitResultPromise = pageStore.submitForm(triggerKey);
            mainStore.setLiveRegion(submitResultPromise.then(() => ""));
            let submitResult = await submitResultPromise;
            if (submitResult == null) {
                submitResult = {
                    Result: 4,
                    Dialog: "Error",
                };
            }
            const resultMap = {
                0: "ValidationFailed",
                1: "Redirect",
                2: "Submitted",
                3: "SubmittedWithRedirect",
                4: "Dialog",
            };
            const segmentView = pageStore.formDataTyped!.getSegmentView(segment, triggerKey);
            let skipCompletion = segmentView.getElementsByFilter(i => isIShouldSkipCompletionElement(i) && (i.shouldSkipCompletion() ?? false)).length > 0;
            let redirectUrl: string | null | undefined = null;
            const resultStr = resultMap[submitResult?.Result as keyof typeof resultMap];
            switch (resultStr) {
                case "Dialog":
                    return async () => {
                        await showDialog(submitResult!.Dialog!, triggerKey);
                        forcingRedirect.value = false;
                        isSubmitting.value = false;
                    };
                case "Redirect":
                    return async () => {
                        if (!pageStore.adminPreview) {
                            forcingRedirect.value = true;
                        }
                        //@ts-ignore
                        window.location = submitResult!.RedirectUrl;
                        isSubmitting.value = false;
                    };
                case "SubmittedWithRedirect":
                    redirectUrl = submitResult!.RedirectUrl;
                //eslint-ignore no-fallthrough
                case "Submitted": {
                    const redirectInFrontendEvenWithoutBackendRedirect = await mainStore.isFeatureFlagActiveAsync(KnownFeatureFlags.RedirectInFrontendEvenWithoutBackendRedirect.Id);
                    if (redirectInFrontendEvenWithoutBackendRedirect || resultStr == "SubmittedWithRedirect") {
                        if (redirectInFrontendEvenWithoutBackendRedirect && isNullOrWhitespace(redirectUrl)) {
                            const postSubmitRedirectElements = segmentView.getElementsByFilter(i => isIPostSubmitRedirectElement(i));
                            redirectUrl = postSubmitRedirectElements.length > 0 ? firstOrNull(await Promise.all(postSubmitRedirectElements.map(item => (item ? (item as IPostSubmitRedirectElement).getPostSubmitRedirect() : null)))) : null;
                        }
                        if (skipCompletion && !isNullOrWhitespace(redirectUrl)) {
                            if (redirectInFrontendEvenWithoutBackendRedirect) {
                                if (!pageStore.adminPreview) {
                                    forcingRedirect.value = true;
                                }
                                window.location.assign(redirectUrl!);
                                isSubmitting.value = false;
                            } else {
                                window.location.assign(redirectUrl!);
                            }
                        }
                    }
                    break;
                }
                case "ValidationFailed":
                    //skipConfirm = false;
                    forcingRedirect.value = false;
                    if (!pageStore.adminPreview || !confirm("Bypass validation? (only shown in preview mode)")) {
                        let targetPage: null | PageDef = null;
                        await showModal(
                            SubmitErrorsModal,
                            {
                                pageGroups: leftPageGroups.value,
                                goToPageFirstError: async (page: PageDef | null) => {
                                    targetPage = page;
                                },
                            },
                            {
                                async closed() {
                                    const page = targetPage ?? currentLeftPage.value;
                                    const firstInvalidElement = await page.firstInvalidElement(false);
                                    const setFocus = () => {
                                        if (firstInvalidElement) {
                                            eventBus.emit("focus", firstInvalidElement.vmId);
                                        } else {
                                            eventBus.emit("focus", page.firstFocusableElement()?.vmId);
                                        }
                                    };
                                    if (targetPage != null && targetPage.id != currentLeftPage.value.id) {
                                        eventBus.emit("change-page", {
                                            page: targetPage,
                                            withError: true,
                                            callback: setFocus,
                                        });
                                    } else {
                                        setFocus();
                                    }
                                },
                            },
                        );
                        return async () => {
                            isSubmitting.value = false;
                        };
                    }
                    break;
                default:
                    debugger;
                    throw new Error(`Unknown type: ${submitResult?.Result}`);
            }
            return async () => {
                isSubmitting.value = false;
                //submitting = false;
                if (pageStore.adminReview) {
                    gotoIndex();
                } else if (!skipCompletion) {
                    await showSubmitSuccessModal(redirectUrl, segment);
                } else {
                    forcingRedirect.value = false;
                }
            };
        };
        const showDialog = async (type: string, triggerKey: string | null) => {
            switch (type) {
                case "Sign":
                    return await showSignDialog(triggerKey);
                case "Error":
                    return await showModal(
                        SubmitFailureModal,
                        {},
                        {
                            async closed() {},
                        },
                    );
                default:
                    throw new Error(`Unimplemented dialog: ${type}`);
            }
        };
        type FormDataBase = NonNullable<(typeof pageStore)["formData"]>;
        interface FormData extends FormDataBase {
            getSegmentView(segment: string | null): BaseElementDefBase;
        }
        const showSignDialog = async (triggerKey: string | null) => {
            let executing = false;
            const signTargets = (await Promise.all((pageStore.formData as FormData).getSegmentView(pageStore.segment).getElementsByFilter(i => isSignatureDef(i) && !i.isSigned))) as SignatureDef[];
            const pdfDataModel = await pageStore.invokeForm({ type: "GenerateSignPreview", target: signTargets[0].id!, segment: pageStore.segment }); // TODO refactor to elsewhere
            const pdfDataArray = Uint8Array.from(atob(pdfDataModel.PdfBase64), c => c.charCodeAt(0));
            showModal(
                SignDialog,
                {
                    pdfData: pdfDataArray,
                    requireUserVerification: signTargets[0].requireUserVerification(),
                    sendVerifyFunction: async (verifyEmail: string, verifyPhoneNumber: string) => {
                        const result = await pageStore.invokeForm({ type: "SendVerifyMessage", target: signTargets[0].id!, segment: pageStore.segment, data: { VerifyEmail: verifyEmail, VerifyPhoneNumber: verifyPhoneNumber } }); // TODO refactor to elsewhere
                        if (result.Success) {
                            return { success: true };
                        } else {
                            return { success: false, messages: result.FailureMessages };
                        }
                    },
                    signAndSubmitFunction: async (signName: string, signDate: string, verifyCode: string) => {
                        executing = true;
                        const result = await pageStore.invokeForm({ type: "Sign", target: signTargets[0].id!, segment: pageStore.segment, data: { EnteredName: signName, EnteredDate: signDate, VerifyCode: verifyCode, PdfHash: pdfDataModel.PdfHash } }); // TODO refactor to elsewhere
                        if (result.Success) {
                            await (
                                await submitFunction(triggerKey)
                            )();
                            executing = false;
                            return { success: true };
                        } else {
                            executing = false;
                            return { success: false, messages: result.FailureMessages };
                        }
                    },
                },
                {
                    "before-closed": function (event: ModalEvent) {
                        if (executing) {
                            event.stop();
                        }
                    },
                    //    'closed': async () => {
                    //        if (!this.adminPreview) {
                    //            if (redirectUrl) {
                    //                this.forcingRedirect = true;
                    //                window.location = redirectUrl;
                    //            } else if (!this.adminReview) {
                    //                await this.gotoIndex();
                    //            } else {
                    //                this.forcingRedirect = false;
                    //            }
                    //        }
                    //    },
                },
            );
        };

        const showReturnDropdown = ref(false);
        const toggleReturnDropdown = () => {
            showReturnDropdown.value = !showReturnDropdown.value;
        };

        const startWorkflowManualOverride = (_event: Event) => {
            let executing = false; // TODO better implementation?
            showModal(
                WorkflowManualOverrideModal,
                {
                    returnFunction: async (type: string, data: object) => {
                        executing = true;
                        var result = await pageStore.workflowManualOverride({ type, data });
                        executing = false;
                        if (result.success) {
                            await showModal(
                                WorkflowManualOverrideSuccessModal,
                                {},
                                //{
                                //    height: "auto",
                                //    width: Math.min(0.9 * window.innerWidth, 600),
                                //    clickToClose: false,
                                //},
                                {
                                    closed: async () => {
                                        if (type == "DeleteWorkflow") {
                                            if (props.settings.inModal) {
                                                emit("close");
                                            } else {
                                                emit("change-page", { page: "Admin" });
                                            }
                                        } else {
                                            // Should this do anything?
                                        }
                                    },
                                },
                            );
                            await delay(600); // avoid error when closing a modal while another is opening - TODO?
                        }
                        return result;
                    },
                },
                //{
                //    height: "auto",
                //    width: Math.min(0.9 * window.innerWidth, 600),
                //    clickToClose: false,
                //},
                {
                    "before-closed": function (event: ModalEvent) {
                        if (executing) {
                            event.stop();
                        }
                    },
                },
            );
        };
        const returnSubmission = async (event: Event) => {
            let returning = false; // TODO better implementation?
            showModal(
                ReturnConfirmModal,
                {
                    returnFunction: async (returningSegment: string, comment: string | null) => {
                        returning = true;
                        var result = isWorkflow.value ? await pageStore.returnDraft({ segment: returningSegment, comment: comment! }) : await pageStore.addCommentAndChangeStatus({ text: comment!, status: "Returned", userName: "Myself", visibleToSubmitter: showComments.value, elementData: pageStore.formData! as FormDef });
                        returning = false;
                        if (result!.success) {
                            await showModal(
                                ReturnSuccessModal,
                                { triggerElement: event.target },
                                {
                                    closed: async () => {
                                        // Should this do anything?
                                        //if (props.settings.inModal) {
                                        //    emit("close");
                                        //} else {
                                        //    emit("change-page", { page: "Admin" });
                                        //}
                                    },
                                },
                            );
                            await delay(600); // avoid error when closing a modal while another is opening - TODO?
                        }
                        return result;
                    },
                    triggerElement: event.target,
                },
                {
                    "before-closed": function (event: ModalEvent) {
                        if (returning) {
                            event.stop();
                        }
                    },
                },
            );
        };

        const startSubmittableStatusChange = (event: Event) => {
            let executing = false;
            showModal(
                ChangeStatusConfirmModal,
                {
                    returnFunction: async (status: string, comment: string | null) => {
                        executing = true;
                        var result = await pageStore.addCommentAndChangeStatus({ text: comment!, status, userName: "Myself", visibleToSubmitter: showComments.value, elementData: pageStore.formData! as FormDef });
                        executing = false;
                        if (result?.success) {
                            showChangeStatusSuccessModal(event);
                        }
                        return result;
                    },
                    triggerElement: event.target,
                },
                {
                    "before-closed": function (event: ModalEvent) {
                        if (executing) {
                            event.stop();
                        }
                    },
                },
            );
        };

        const showChangeStatusSuccessModal = (event: Event) => {
            showModal(ChangeStatusSuccessModal, { triggerElement: event.target });
        };

        const showDeleteSuccessModal = (event?: Event, asAdmin?: boolean) => {
            showModal(
                DeleteSuccessModal,
                { asAdmin: asAdmin, triggerElement: event?.target },
                {
                    closed: async () => {
                        gotoIndex();
                    },
                },
            );
        };

        const deleteDraft = async (asAdmin: boolean, _event: Event) => {
            throwIfViewOnly();
            let deleting = false; // TODO better implementation?
            let deleted = false; // TODO better implementation?
            showModal(
                DeleteConfirmModal,
                {
                    asAdmin: asAdmin,
                    deleteFunction: async () => {
                        deleting = true;
                        await pageStore.deleteDraft({ asAdmin: asAdmin });
                        deleting = false;
                        deleted = true;
                    },
                },
                //{
                //    height: "auto",
                //    width: Math.min(0.9 * window.innerWidth, 600),
                //    clickToClose: false,
                //},
                {
                    "before-closed": function (event: ModalEvent) {
                        if (deleting) {
                            event.stop();
                        }
                    },
                    async closed() {
                        if (deleted) {
                            gotoIndex();
                        }
                    },
                },
            );
        };

        const showSubmitSuccessModal = async (redirectUrl: string | null | undefined, segment: string | null) => {
            if (segment == "NOMATCH") {
                const completedSegments = pageStore.visibleSegments!;
                segment = completedSegments.length > 0 ? completedSegments[completedSegments.length - 1].id! : null;
            }
            let receiptContents = await Promise.all(
                pageStore
                    .formDataTyped!.getSegmentView(segment, null)
                    .getElementsByFilter2(isICustomReceiptElement)
                    .map(item => item.visible().then(v => (v ? item.receiptContents() : []))),
            );
            receiptContents = Array.prototype.concat.apply([], receiptContents);
            let viewTypes = (
                await Promise.all(
                    pageStore
                        .formDataTyped!.getSegmentView(segment, null)
                        .getElementsByFilter2(isICustomViewElement)
                        .map(async item => {
                            if (await item.visible()) {
                                return item.viewTypes();
                            } else {
                                return [];
                            }
                        }),
                )
            ).flat();
            if ((viewTypes.length == 0 || pageStore.formSettings!.showBuiltinPdf == null || pageStore.formSettings!.showBuiltinPdf) && !viewTypes.includes("Builtin")) {
                viewTypes.unshift("Builtin");
            }
            const hasFileUploads = pageStore.formDataTyped!.getSegmentView(segment, null).getElementsByFilter(i => (i as unknown as { isFileUpload: boolean }).isFileUpload).length > 0;
            const documents = await Promise.all(
                viewTypes
                    .filter(i => !["Builtin"].includes(i))
                    .map(async view => {
                        return {
                            url: await mainStore.getUrl("downloadDocument", { areaCode: pageStore.formTenantCode, formId: pageStore.formId, document: view }),
                            text: view == "Builtin" || view == "Default" || view == null ? "Submission" : view,
                        };
                    }),
            );
            if (hasFileUploads) {
                documents.push({
                    url: await mainStore.getUrl("submissionGotoAttachments", { areaCode: pageStore.formTenantCode, formId: pageStore.formId }),
                    text: "Attached File(s)",
                });
            }
            if (hasFileUploads || viewTypes.length > 1) {
                documents.push({
                    url: await mainStore.getUrl("submissionGotoAllDocuments", { areaCode: pageStore.formTenantCode, formId: pageStore.formId }),
                    text: "All Documents",
                });
            }

            showModal(
                SubmitSuccessModal,
                {
                    redirectUrl,
                    documents,
                    submissionUrl: await mainStore.getUrl("submissionGoto", { areaCode: pageStore.formTenantCode, formId: pageStore.formId, viewType: "Builtin" }),
                    receiptContents: receiptContents,
                    adminPreview: pageStore.adminPreview,
                },
                {
                    closed: async () => {
                        if (!pageStore.adminPreview) {
                            if (redirectUrl) {
                                forcingRedirect.value = true;
                                //@ts-ignore
                                window.location = redirectUrl;
                            } else if (!pageStore.adminReview) {
                                if ((pageStore.availableSegments?.length ?? 0) > 0 && (await mainStore.isFeatureFlagActiveAsync(KnownFeatureFlags.ChainForms.Id))) {
                                    forcingRedirect.value = false;
                                } else {
                                    gotoIndex();
                                }
                            } else {
                                forcingRedirect.value = false;
                            }
                        }
                    },
                },
            );
        };

        const resendEmail = async (segment: string, commentRequired: boolean, eventType: string, type: string) => {
            let resend = false;
            showModal(
                ResendConfirmModal,
                {
                    commentRequired: commentRequired,
                    type: type,
                    resendFunction: async (comment: string) => {
                        resend = true;
                        const result = await pageStore.resendEmail({ segment, comment, eventType });
                        resend = false;
                        if (result.success) {
                            showResendSuccessModal(type);
                        }
                        return result;
                    },
                },
                //{
                //    height: "auto",
                //    width: Math.min(0.9 * window.innerWidth, 600),
                //    clickToClose: false,
                //},
                {
                    "before-closed": function (event: ModalEvent) {
                        if (resend) {
                            event.stop();
                        }
                    },
                    closed: async () => {
                        // Should this do anything?
                    },
                },
            );
        };

        const showResendSuccessModal = (type: string) => {
            showModal(
                ResendSuccessModal,
                { type: type },
                {
                    closed: async () => {
                        // Should this do anything?
                    },
                },
            );
        };

        const showLoadingModal = (title: string, loadingPromise: Promise<void[]>) => {
            showModal(LoadingModal, { title, loadingPromise });
        };

        const setShowPagenav = (value: boolean) => {
            showPageNav.value = value;
        };

        const setCurrentSegment = (segment: StateFormDef) => {
            currentSegment.value = segment;
        };

        const setCurrentLeftPage = (page: PageDef) => {
            currentLeftPage.value = page;
        };

        provide(gotoIndexInjectKey, gotoIndex);
        provide(forceLoginInjectKey, forceLogin);
        provide(submitInjectKey, (triggerKey: string | null, event: Event) => submit(triggerKey, event));
        provide(deleteDraftInjectKey, (asAdmin: boolean, event: Event) => deleteDraft(asAdmin, event));
        provide(pageStatusFetcherInjectKey, () => pageStatus.value);
        provide(resendEmailInjectKey, (segment: string, commentRequired: boolean, eventType: string, type: string) => resendEmail(segment, commentRequired, eventType, type));
        provide(loadingInjectKey, (title: string, loadingPromise: Promise<void[]>) => showLoadingModal(title, loadingPromise));
        provide(submitButtons$InjectKey, submitButtons$);

        const updateHistory = () => {
            if (adminPreview.value || adminReview.value) {
                return; // TODO?
            }
            if (pageStore.formData != null) {
                const formId = pageStore.formId;
                const page = leftPage.value || 0;
                emit("update-page", { areaCode: pageStore.formTenantCode, areaUrlSlug: null, formId: formId, page: page }, !initialLoadFinished.value);
            }
        };
        //watch(
        //    () => formData.value,
        //    () => {
        //        debugger;
        //        formData$.next(formData.value);
        //    },
        //    { immediate: true },
        //);
        watch(
            () => pageStore.formTenantCode,
            () => {
                updateHistory();
            },
        );
        watch(
            () => pageStore.formId,
            () => {
                updateHistory();
            },
        );
        watch(
            () => leftPage.value,
            () => {
                updateHistory();
            },
        );
        updateHistory();

        onMounted(() => {
            //TODO better implementation?
            document.addEventListener(
                "click",
                event => {
                    const dropdownBtn = document.getElementById("dropdownBtn");
                    const dropdownMenu = document.getElementById("dropdownMenu");
                    if (!!dropdownMenu && !dropdownMenu.contains(event.target as Node) && !!dropdownBtn && !dropdownBtn.contains(event.target as Node)) {
                        dropdownMenu.classList.remove("show");
                    }
                },
                { passive: true },
            );
        });

        const watchers: ReturnType<typeof watch>[] = [];
        let initedReviewPane = false;
        const initReviewPane = () => {
            if (hasIssues.value) {
                reviewTab.value = "issues";
                leftWidth.value = 35;
            } else if (leftPageGroups.value.length > 0) {
                reviewTab.value = "task";
                leftWidth.value = 50;
            } else if (showComments.value) {
                reviewTab.value = "comments";
                leftWidth.value = 25;
            }
            if (!initedReviewPane) {
                initedReviewPane = true;
                watchers.push(
                    watch(
                        () => leftPageGroups.value,
                        (val, oldVal) => {
                            if (val.length > 0 && oldVal.length == 0) {
                                initReviewPane();
                            }
                        },
                    ),
                );
                watchers.push(
                    watch(
                        () => hasIssues.value,
                        (val, oldVal) => {
                            // TODO - permission/access?
                            if ((!val && reviewTab.value == "issues") || (val && !oldVal)) {
                                initReviewPane();
                            }
                        },
                    ),
                );
            }
        };
        onUnmounted(() => {
            for (const watcher of watchers) {
                watcher();
            }
        });

        const init = () => {
            forcingRedirect.value = false;
            initialLoadFinished.value = false;
            showLoginSlidedown.value = false;
            pageStatus.value = {};
            pageStatusSubscriptions.value = [];
            let areaUrlSlug, areaCode, formName, formVersion, formId, formHash, testMode, urlSlug;
            let page = 0 as number | undefined;
            let loadPromise = null;
            if (props.settings.adminPreview) {
                let previewData = props.settings.previewData;
                if (previewData == null) {
                    const extraDataString = document.getElementById("extraData")!.innerHTML;
                    previewData = JSON.parse(extraDataString);
                }
                ({ areaUrlSlug, areaCode, formName, formVersion, formHash, formId } = previewData.form);
                page = (previewData.page || 0) + 1;
                loadPromise = pageStore.loadAdminPreviewFormData(previewData);
            } else if (props.settings.adminReview) {
                //const reviewData = await getData(this.$store, 'Admin',
                //    () => this.$root.getUrl('adminSearchReviewData', { formId: props.settings.formId, pageNumber: null /* TODO remove? */ }),
                //    i => true /* TODO i.definition.formId == props.settings.formName && i.definition.formVersion == props.settings.formVersion*/
                //);
                //({ formName, formVersion, formHash, formId } = reviewData.form);
                //page = reviewData.page+1;
                const extraDataString = document.getElementById("extraData")?.innerHTML;
                const preloadedData = extraDataString == null ? null : (JSON.parse(extraDataString) as any); // eslint-disable-line @typescript-eslint/no-explicit-any
                //page = 0;
                testMode = props.settings.testMode?.toString()?.toLowerCase() == "true";
                loadPromise = pageStore.loadAdminReviewFormData({ areaUrlSlug: props.settings.areaUrlSlug, areaCode: props.settings.areaCode, formId: props.settings.formId, formName: preloadedData != null && preloadedData.formName != null ? preloadedData.formName : props.settings.formName, formVersion: preloadedData != null && preloadedData.formVersion != null ? preloadedData.formVersion : props.settings.formVersion, testMode, urlSlug: preloadedData != null && preloadedData.urlSlug != null ? preloadedData.urlSlug : urlSlug, preloadedData });
            } else {
                const externalData = {} as Record<string, string[]>;
                const searchParams = new URLSearchParams(window.location.search);
                const agParamKeys = ["formHash", "testMode"];
                for (const [key, value] of Array.from(searchParams.entries())) {
                    if (agParamKeys.includes(key)) continue;
                    if (key in externalData) {
                        externalData[key].push(value);
                    } else {
                        externalData[key] = [value];
                    }
                }
                ({ areaUrlSlug, areaCode, formName, formVersion, formId, formHash, urlSlug } = props.settings);
                //@ts-ignore
                page = (props.settings.page ?? 0) * 1;
                testMode = props.settings.testMode?.toString()?.toLowerCase() == "true";
                loadPromise = pageStore.loadFormData({
                    areaUrlSlug,
                    areaCode,
                    formId,
                    formName,
                    formVersion,
                    formHash,
                    testMode,
                    urlSlug,
                    externalData,
                });
            }
            (async () => {
                pageStore.isSaveDisabledOnSectionChange = await useMainStore().isFeatureFlagActiveAsync("DisableSaveOnSectionChange");
            })();

            const load = async () => {
                if (!adminPreview.value) {
                    if (pageStore.directLinkTemplates.length > 0) {
                        const url = (pageStore.directLinkTemplates[0].definition.settings as DirectLinkTemplateSettings).target;
                        window.location.assign(url!);
                    }
                    if (adminReview.value) {
                        initReviewPane();
                    } else {
                        //const aCount = pageStore.activeSegments?.length??0;
                        //console.log(`${aCount} active segments`);
                        //const bCount = pageStore.availableSegments?.length??0;
                        //console.log(`${bCount} available segments`);
                        //const vCount = pageStore.visibleSegments?.length??0;
                        //console.log(`${vCount} visible segments`);
                        if (pageStore.status == StandardFormStatus.Deleted) {
                            showDeleteSuccessModal();
                        } else {
                            const available = pageStore.isWorkflow ? (pageStore.availableSegments ?? []).length > 0 : pageStore.endUserStatuses.includes(pageStore.status) && pageStore.formData!.locks.length == 0;
                            if (!available) {
                                let lockActions: LockAction[] = [];
                                let lock: string | undefined = undefined;
                                let lockSegmentId: string | undefined = undefined;
                                if (pageStore.isWorkflow) {
                                    let lockableSegment = firstOrNull((pageStore.unlockableSegments ?? []).filter(i => i.locks.length > 0));
                                    if (lockableSegment != null) {
                                        lockSegmentId = lockableSegment!.id!;
                                        lock = lockableSegment.locks[0];
                                        lockActions = lockableSegment.getLockActions(lock);
                                    }
                                } else {
                                    const locks = pageStore.formData!.locks;
                                    if (locks.length > 0) {
                                        lock = locks[0];
                                        lockActions = pageStore.formData!.getLockActions(lock);
                                    }
                                }
                                if (lock != null) {
                                    const submitFunction = async (lockAction: LockAction | { alreadyUnlocked?: boolean }) => {
                                        while ("redirectUrl" in lockAction && lockAction.redirectUrl != null && lockAction.redirectUrl instanceof Function) {
                                            lockAction = await lockAction.redirectUrl();
                                        }
                                        if ("alreadyUnlocked" in lockAction && lockAction.alreadyUnlocked) {
                                            init();
                                        } else if ("unlock" in lockAction && lockAction.unlock) {
                                            await pageStore.invokeForm({ type: "Unlock", target: lock, segment: lockSegmentId, unlock: true });
                                            init();
                                        } else if ("redirectUrl" in lockAction && lockAction.redirectUrl != null) {
                                            window.location.assign(lockAction.redirectUrl as string);
                                        } else {
                                            alert("You cannot edit this submission at this time");
                                        }
                                    };
                                    showModal(
                                        LockActionModal,
                                        {
                                            submitFunction: submitFunction,
                                            lockActions: lockActions,
                                        },
                                        {
                                            "before-closed": function (event: ModalEvent) {
                                                event.stop();
                                            },
                                        },
                                    );
                                    return;
                                }
                                if (pageStore.segment == "NOMATCH") {
                                    const completedSegments = pageStore.visibleSegments ?? [];
                                    pageStore.segment = completedSegments.length > 0 ? completedSegments[completedSegments.length - 1].id! : null;
                                }
                                const segmentView = pageStore.formDataTyped!.getSegmentView(pageStore.segment, null);
                                const skipCompletion = segmentView.getElementsByFilter(i => isIShouldSkipCompletionElement(i) && (i.shouldSkipCompletion() ?? false)).length > 0;
                                const postSubmitRedirectElements = segmentView.getElementsByFilter(i => isIPostSubmitRedirectElement(i));
                                const redirectUrl = postSubmitRedirectElements.length > 0 ? firstOrNull(await Promise.all(postSubmitRedirectElements.map(item => (item ? (item as IPostSubmitRedirectElement).getPostSubmitRedirect() : "")))) : "";
                                if (!skipCompletion) {
                                    showSubmitSuccessModal(redirectUrl, null);
                                    return;
                                } else if (redirectUrl != null) {
                                    window.location.assign(redirectUrl);
                                    return;
                                }
                            }
                        }
                    }
                    if (leftPageGroups.value.length > 0) {
                        leftPage.value = page!;
                        rightPage.value = 0;
                    } else {
                        leftPage.value = 0;
                        rightPage.value = page!;
                    }
                }
                nextTick(() => {
                    initialLoadFinished.value = true;
                });
            };

            loadPromise.then(
                async () => {
                    while (pageStore.isWorkflow == null || (pageStore.isWorkflow && pageStore.availableSegments == null)) {
                        await delay(10);
                    }
                    await load();
                },
                (e: unknown) => {
                    if (e != null && (e as Error).message == "NotFound") {
                        changePage({ page: "PageNotFound" });
                    } else {
                        debugger;
                        throw e;
                    }
                },
            );
            if (formName != null && formVersion != null && !(props.settings.adminPreview || props.settings.adminReview || (props.settings.testMode && props.settings.testMode != "false"))) {
                (async () => {
                    const url = await mainStore.getUrl("addView", { areaUrlSlug: areaUrlSlug, tenantCode: areaCode });
                    const formData = new FormData();
                    formData.append("formName", formName);
                    formData.append("formVersion", formVersion);
                    await fetchXsrf(mainStore, url, {
                        method: "POST",
                        credentials: "same-origin",
                        body: formData,
                    });
                })();
            }
        };

        onActivated(() => {
            if (isInitialCreate.value) {
                isInitialCreate.value = false;
            } else {
                init();
            }
        });

        init();

        const exposed = {
            //refs
            ReviewContainer,

            // state
            leftPage,
            leftPageGroups,
            rightPage,
            rightPageGroups,
            verifyData,
            verifyFailureMessages,
            activeSegments,
            enabledPages,
            formId,
            testMode,
            adminReview,
            showComments,
            showHistory,
            showFiles,
            isInitialCreate,
            forcingRedirect,
            initialLoadFinished,
            showLoginSlidedown,
            showPageNav,
            currentSegment,
            //skipConfirmModal,
            isSubmitting,
            hasIssues,
            pageStatus,
            pageStatusSubscriptions,
            reviewTab,
            leftWidth,
            leftWidthPercentage,
            dividerLeft,
            tempLeftWidth,
            resizableLeft,
            resizableRight,
            formDataLoading,
            isWorkflowManualOverrideVisible,
            isSubmittableStatusChangeVisible,
            isSubmittableDeleteVisible,
            isWorkflowReturnVisible,
            isWorkflowReturnEnabled,
            isWorkflow,
            hasPartiallyCompletedForms,
            isViewOnly,
            isOffline,
            hasMultiplePages,
            //method
            startWorkflowManualOverride,
            returnSubmission,
            deleteDraft,
            startSubmittableStatusChange,
            changeReviewTab,
            increaseLeftWidth,
            decreaseLeftWidth,
            resizeDragMove,
            resizeDragEnd,
            resizeDragStart,
            setLeftPage,
            setRightPage,
            setShowPagenav,
            setCurrentSegment,
            setCurrentLeftPage,

            showReturnDropdown,
            toggleReturnDropdown,
        };

        ("#if JEST");
        //@ts-ignore
        exposed.showDialog = showDialog;
        //@ts-ignore
        exposed.forceLogin = forceLogin;
        //@ts-ignore
        exposed.gotoIndex = gotoIndex;
        //@ts-ignore
        exposed.resendEmail = resendEmail;
        //@ts-ignore
        exposed.submit = submit;
        //@ts-ignore
        exposed.submitFunction = submitFunction;
        ("#endif");

        return exposed;
    },
});
</script>
